const literalToSeconds = literal => {
  const [mins, seconds] = literal.split(':');

  return Number(mins) * 60 + Number(seconds);
};

export const detectTimestamps = (description, videoLength) => {
  const re = /\d{1,2}:\d{2}/g;

  const result = [];
  let stamp;

  while ((stamp = re.exec(description)) !== null) {
    const time = literalToSeconds(stamp[0]);

    if (!(time > videoLength)) {
      result.push({
        time,
        endIndex: re.lastIndex,
        literal: stamp[0],
      });
    }
  }

  return result;
};
